
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="container mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold mb-8">About H44S</h1>
        <div className="prose max-w-none">
          <p className="text-lg mb-6">
            H44S is a platform connecting entrepreneurs with investors, 
            facilitating the growth of innovative businesses through strategic partnerships.
          </p>
          <h2 className="text-2xl font-semibold mt-8 mb-4">Our Mission</h2>
          <p className="mb-6">
            Our mission is to empower entrepreneurs by providing them with the resources, 
            connections, and capital they need to turn their innovative ideas into successful businesses.
          </p>
          <h2 className="text-2xl font-semibold mt-8 mb-4">Our Vision</h2>
          <p className="mb-6">
            We envision a world where great ideas can easily find the support they need to flourish, 
            creating value for entrepreneurs, investors, and society at large.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutPage;
